var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('IntroSection'),_vm._v(" "),_c('ProfilesSection'),_vm._v(" "),_c('NewsSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }